import { Button, Card, Form, TextFieldC } from '../../components'
import { Box } from '@mui/material'
import Yup from '../../utils/helpers/Yup'
import { useAuth } from '../../lib/auth'
import { useLocation, useNavigate } from 'react-router-dom'

type FormValues = {
  username: string
  password: string
}

const defaultValues = {
  username: '',
  password: ''
}

const schema = Yup.object({
  username: Yup.string().required(),
  password: Yup.string().required()
})

const LoginForm = (props: { id: string }) => {
  const { id } = props
  const { login } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()

  const handleSubmit = async (data: FormValues) => {
    const user = await login(data)

    if (user?.username) {
      // Verifica se há uma rota de origem válida e não é a página de login
      const from = location.state?.from?.pathname
      const isValidFrom = from && from !== '/login' && from !== '/'

      // Se não houver uma rota válida ou for a página de login, redireciona para home
      navigate(isValidFrom ? from : '/orders', { replace: true })
    }
  }
  return (
    <div style={{ marginBottom: 20 }}>
      <Form<FormValues>
        id={id}
        onSubmit={handleSubmit}
        schema={schema}
        options={{ defaultValues }}
      >
        <TextFieldC
          name="username"
          style={{ marginBottom: 15 }}
          label="Usuário"
        />
        <TextFieldC
          name="password"
          style={{ marginBottom: 10 }}
          label="Senha"
          type="password"
        />
      </Form>
    </div>
  )
}

export const LoginPage = () => {
  const { isLoggingIn } = useAuth()
  return (
    <Box
      style={{
        display: 'flex',
        height: '100vh',
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center'
      }}
      sx={{ background: { xs: 'white', sm: '#edf0ef' } }}
    >
      <Box
        style={{
          padding: '32px',
          width: '100%'
        }}
        sx={{
          display: { xs: 'block', sm: 'none' }
        }}
      >
        <div>
          <div
            style={{
              display: 'flex',
              marginBottom: 50,
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <img src="/logo.png" alt="logo" width={200} />
          </div>
          <LoginForm id="mobile-login-form" />

          <Button
            loading={isLoggingIn}
            type="submit"
            form="mobile-login-form"
            style={{ width: '100%' }}
          >
            Entrar
          </Button>
        </div>
      </Box>
      <Box
        sx={{
          display: { xs: 'none', sm: 'block' },
          width: { xs: 400, sm: 400, md: 400, lg: 400, xl: 400 }
        }}
      >
        <Card
          style={{
            padding: '32px'
          }}
        >
          <div>
            <div
              style={{
                display: 'flex',
                marginBottom: 50,
                justifyContent: 'center',
                alignItems: 'center'
              }}
            >
              <img src="/logo.png" alt="logo" width={100} />
            </div>
            <LoginForm id="desktop-login-form" />
            {/* <div
              style={{
                display: 'flex',
                marginBottom: 30,
                justifyContent: 'flex-end'
              }}
            >
              <a style={{ cursor: 'pointer', color: '#29aaa7' }}>
                Esqueci minha senha
              </a>
            </div> */}
            <Button
              loading={isLoggingIn}
              type="submit"
              form="desktop-login-form"
              style={{ width: '100%' }}
            >
              Entrar
            </Button>
            {/* <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center'
              }}
            >
              <div>Não tem uma conta?</div>
              <a style={{ marginLeft: 5, color: '#29aaa7', cursor: 'pointer' }}>
                Registre-se
              </a>
            </div> */}
          </div>
        </Card>
      </Box>
    </Box>
  )
}
